import React from 'react';

import { faCheck } from '@fortawesome/free-solid-svg-icons/faCheck';
import { faTimes } from '@fortawesome/free-solid-svg-icons/faTimes';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Box, COLORS, Text } from '@clutter/clean';

export const PasswordMatches: React.FC<{
  password: string;
  confirmation: string;
}> = ({ password, confirmation }) => {
  const valid = password.length > 0 && confirmation.length > 0 && password === confirmation;

  return (
    <Box.Flex flexDirection="column" gap="2px">
      <Text.Callout color={valid ? COLORS.storm : COLORS.toucan}>
        <FontAwesomeIcon fixedWidth icon={valid ? faCheck : faTimes} /> Must match.
      </Text.Callout>
    </Box.Flex>
  );
};
